
import * as React from 'react';

import * as styles from './overlayParagraph.scss';

type Props = {
    children: React.ReactNode;
}

const OverlayParagraph:React.SFC<Props> = (props) => {
    return (
        <div className={styles.copy}>
            {props.children}
        </div>
    );  
}

export default OverlayParagraph;
